import { type WindowType, type CapitalizeFirstLetter } from './_types';

export const capitalize = <T extends string>(str: T) =>
  (str.charAt(0).toUpperCase() + str.slice(1)) as CapitalizeFirstLetter<T>;

// Initialize state with undefined width/height so server and client renders match
export const initialScreenValues: WindowType = {
  width: undefined,
  offsetWidth: undefined,
  height: undefined,
  screenHeight: undefined,
};
